<script setup lang="ts">
import { FieldNodePageFieldSidebarWidgets, ParagraphAnchors, ToccoSeminarFieldsFragment } from '~/api/graphql/generated'
import { Link } from '~/types'
import { useSchemaToccoBase } from '~/composables/useSchemaToccoBase'

useNoCache()

const props = defineProps<{
  entity: ToccoSeminarFieldsFragment
  breadcrumbs?: Link[]
}>()

// Add schema.org JSON-LD structured data
useSchemaToccoBase(props.entity, 'seminar')

const introtext = computed(() => props.entity.fieldLead?.processed || '')
useSections(props.entity.fieldWidgets)
</script>

<template>
  <SectionHero :entity="entity" :breadcrumbs="breadcrumbs" type="petrol" />
  <SectionIntrotext v-if="introtext" :text="introtext" data-id="lead" />
  <SectionAnchors v-if="entity.fieldAnchors?.entity" :entity="entity.fieldAnchors.entity as ParagraphAnchors" />
  <SectionSidebar :sidebar="entity.fieldSidebarWidgets as FieldNodePageFieldSidebarWidgets[]" />
  <Sections :entity="entity" />
  <SectionToccoDownloads :entity="entity" data-id="downloads" />
  <SectionToccoShare />
  <SectionToccoSeminarModules :entity="entity" data-id="modules" />
  <SectionToccoEmployees :entity="entity" data-id="responsibles" />
  <SectionToccoRelatedSeminars :entity="entity" data-id="related-seminars" />
</template>
